module.exports = __webpack_public_path__ + "img/1648801869045profilbildriccardodellantonio.f69c7eea.jpg";